module.exports = __webpack_public_path__ + "static/media/hsbc.5c970e39.png";